import * as React from 'react'
import { Helmet } from 'react-helmet'

export const getGoogleFontsLink = (fonts: string[]) =>
  `https://fonts.googleapis.com/css2?${fonts
    .map(
      (font) =>
        `family=${font.replace(
          / /g,
          '+',
        )}:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800`,
    )
    .join('&')}&display=swap`

export const GoogleFontsClient: React.SFC<{
  fonts: (string | undefined)[]
}> = ({ fonts }) => {
  const filteredFonts = fonts.filter<string>((font): font is string => typeof font === 'string')
  return filteredFonts.length > 0 ? (
    <Helmet>
      <link href={getGoogleFontsLink(filteredFonts)} rel="stylesheet" />
    </Helmet>
  ) : null
}
